(function () {
  if (window.__mpHomepageInit) return;
  window.__mpHomepageInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var items = document.querySelectorAll('[data-mp-reveal]');
    if (!items.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initCarousels() {
    document.querySelectorAll('[data-mp-carousel]').forEach(function (root) {
      if (root.dataset.mpReady === 'true') return;
      root.dataset.mpReady = 'true';

      var rail = root.querySelector('[data-mp-carousel-rail]');
      var dots = root.querySelector('[data-mp-carousel-dots]');
      var prev = root.querySelector('[data-mp-carousel-prev]');
      var next = root.querySelector('[data-mp-carousel-next]');
      if (!rail) return;

      function step() {
        var first = rail.querySelector('[data-mp-carousel-item]');
        if (!first) return rail.clientWidth * 0.8;
        var gap = parseFloat(window.getComputedStyle(rail).columnGap || window.getComputedStyle(rail).gap || 0);
        return first.getBoundingClientRect().width + gap;
      }

      function index() {
        return Math.max(0, Math.round(rail.scrollLeft / step()));
      }

      function updateDots() {
        if (!dots) return;
        var active = index();
        dots.querySelectorAll('button').forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === active);
        });
      }

      if (dots && !dots.children.length) {
        rail.querySelectorAll('[data-mp-carousel-item]').forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'mp-carousel-dot';
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.addEventListener('click', function () {
            rail.scrollTo({ left: i * step(), behavior: reduced ? 'auto' : 'smooth' });
          });
          dots.appendChild(dot);
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          rail.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          rail.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' });
        });
      }

      rail.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateDots);
      }, { passive: true });
      updateDots();
    });
  }

  function init() {
    initReveal();
    initCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
